import React from 'react';
import { Lock, Zap } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
interface FinalCTAProps {
  onAddToCart?: () => void;
}
export function FinalCTA({
  onAddToCart
}: FinalCTAProps) {
  return <section className="scroll-mt-8 py-32 bg-slate-900 relative overflow-hidden" data-id="element-50">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-96 bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-51" />

      <div id="final-cta" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-52">
        <ScrollFadeIn data-id="element-53">
          <h2 className="text-4xl md:text-5xl font-serif text-slate-50 mb-6" data-id="element-54">
            Stop Fighting Your Biology.
            <br data-id="element-55" />
            <span className="text-amber-500 italic" data-id="element-56">
              Start Switching It Off.
            </span>
          </h2>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-57">
          <p className="text-xl text-slate-300 mb-12 leading-relaxed" data-id="element-58">
            Get the complete "Cortisol Switch" system today and reclaim your
            sleep, your energy, and your waistline.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-59">
          <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
            <div className="mb-8" data-id="element-61">
              <span className="text-slate-400 uppercase tracking-widest text-sm font-semibold" data-id="element-62">
                Digital Access
              </span>
              <div className="mt-3 flex items-center justify-center gap-3" data-id="element-63">
                <span className="text-2xl text-slate-500 line-through font-medium" data-id="element-64">
                  $37
                </span>
                <span className="text-5xl font-bold text-slate-50" data-id="element-65">$6.39</span>
              </div>
              <div className="mt-3 inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/15 border border-emerald-500/30" data-id="element-66">
                <span className="text-emerald-400 text-sm font-semibold tracking-wide" data-id="element-67">
                  🔥 83% OFF — Precio de Lanzamiento
                </span>
              </div>
            </div>

            <a href="https://www.recursosencalma.com/cart/45769486663853:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="cta-pulse w-full sm:w-auto inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-slate-900 bg-amber-500 rounded-xl hover:bg-amber-400 transition-colors duration-300 mb-6" data-id="element-68">
              Download The Cortisol Switch Now
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-6 text-sm text-slate-400" data-id="element-69">
              <div className="flex items-center" data-id="element-70">
                <Lock className="w-4 h-4 mr-2 text-emerald-400" data-id="element-71" />
                Secure Checkout
              </div>
              <div className="hidden sm:block text-slate-600" data-id="element-72">•</div>
              <div className="flex items-center" data-id="element-73">
                <Zap className="w-4 h-4 mr-2 text-amber-400" data-id="element-74" />
                Immediate Digital Access
              </div>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}